import { useEffect, useState } from 'react';

import { CheckedListItem } from '~/svgs';
import { LayoutGroup } from 'framer-motion';
import { NextLink } from '~/i18n';
import { useFormContext } from 'react-hook-form';
import { useRouter } from 'next/router';

type ProductDetailsProps = {
   NavigationLinks: any[];
};

type NavigationItemProps = {
   isComplete: boolean;
   isCurrent: boolean;
   text: string | React.ReactNode;
   icon: React.ReactNode;
   href?: string;
   id?: string;
   idx?: number | string;
   childrenItems?: any;
   toggle?: boolean;
   setToggle?: any;
   requireStatus?: boolean;
};

export const FormNavigation = ({ NavigationLinks }: ProductDetailsProps) => {
   const router = useRouter();
   const { query } = useRouter();
   const { getValues } = useFormContext() || {};
   const id = query.id as string;
   const formValues = getValues?.();
   const layoutLinks = [...NavigationLinks];
   return (
      <LayoutGroup>
         <div className="h-[65vh] overflow-y-auto [&::-webkit-scrollbar]:hidden mt-2">
            <ul className="relative space-y-2 overflow-hidden text-sm ">
               {layoutLinks.map(
                  (
                     {
                        required_form_field,
                        href,
                        text,
                        icon,
                        children,
                        requireStatus,
                        id: idx,
                     }: any,
                     index: any
                  ) => {
                     const _reqrdField = formValues[required_form_field];
                     const isCurrent = router.pathname.includes(href);
                     let isComplete = false;
                     if (_reqrdField) {
                        if (children) {
                           const _children = children.filter(
                              (child: any) => child.required_form_field
                           );
                           const _childrenValues = _children.map(
                              (child: any) => formValues[child.required_form_field]
                           );
                           const _isCompleteChildren = _childrenValues.every((value: any) => value);
                           isComplete = _isCompleteChildren;
                        } else {
                           isComplete = true;
                        }
                     }
                     return (
                        <div key={index}>
                           <NavigationItem
                              idx={idx}
                              isComplete={isComplete}
                              isCurrent={isCurrent}
                              text={text}
                              icon={icon}
                              href={href}
                              id={id}
                              childrenItems={children}
                              requireStatus={requireStatus}
                           />
                        </div>
                     );
                  }
               )}
            </ul>
         </div>
      </LayoutGroup>
   );
};

const NavigationItem = (props: NavigationItemProps) => {
   const { isComplete, isCurrent, text, icon, href, childrenItems } = props;
   const [toggle, setToggle] = useState(false);
   const { query } = useRouter();
   useEffect(() => {
      if (isCurrent) {
         setToggle(true);
      }
   }, [isCurrent]);

   const cleanUrl = (url: string | undefined) => url?.replace(/\/{2,}/g, '/');

   const modifiedHref = cleanUrl(
      href
         ?.replace(':id', (query?.id as string) || '')
         ?.replace(':applicationNo', (query?.applicationNo as string) || '')
   );

   return (
      <li
         className={`group relative text-base  ${
            isComplete || isCurrent ? 'text-primary' : 'text-grey-200'
         } ${!isComplete && !isCurrent && 'cursor-not-allowed pointer-events-none'} 
         rounded-md hover:bg-[#3081381a] hover:[&>*]:fill-primary hover:[&>*]:text-primary hover:before:absolute hover:before:w-1 hover:before:left-0 rtl:hover:before:right-0 hover:before:bg-primary hover:before:h-full hover:before:rounded-l rtl:hover:before:rounded-r`}>
         <NextLink href={`/umrah-requests` + `${modifiedHref}`}>
            <NavigationInnerItem
               isComplete={isComplete}
               isCurrent={isCurrent}
               text={text}
               icon={icon}
               toggle={toggle}
               setToggle={setToggle}
               childrenItems={childrenItems}
            />
         </NextLink>
      </li>
   );
};

const NavigationInnerItem = (props: NavigationItemProps) => {
   const { isComplete, isCurrent, text, icon } = props;
   return (
      <div className="flex items-center justify-between px-4 py-2">
         <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-4">
               <span
                  className={`group-hover:[&>svg>*]:fill-primary ${
                     (isComplete || isCurrent) && '[&>svg>*]:fill-primary'
                  }`}>
                  {icon}
               </span>
               <span className={`${isCurrent ? 'font-bold' : 'font-semibold'}`}>{text}</span>
            </div>
            <div className="flex items-center gap-2">
               {isComplete ? <CheckedListItem className="!w-4 !h-4 ml-auto rtl:mr-auto" /> : null}
            </div>
         </div>
      </div>
   );
};
